<template>
    <div class="page">
        <div class="page-content">
            <el-descriptions title="资金数据" :column="4" border>
                <el-descriptions-item label-class-name="my-label" content-class-name="my-content" label="系统总抵扣券">{{ getSystemAllMoney.userMoney }}</el-descriptions-item>
                <el-descriptions-item label-class-name="my-label" content-class-name="my-content" label="系统总贡献值">{{ getSystemAllMoney.userScore }}</el-descriptions-item>
                <el-descriptions-item label-class-name="my-label" content-class-name="my-content" label="系统总悦豆">{{ getSystemAllMoney.currency8 }}</el-descriptions-item>
                <el-descriptions-item label-class-name="my-label" content-class-name="my-content" label="系统总悦果">{{ getSystemAllMoney.currency9 }}</el-descriptions-item>
            </el-descriptions>

            <div class="data-list">
                <div class="title">加权模拟</div>
                <el-divider></el-divider>
                <div class="itme-data title-txt">
                    <span style="width: 200px">今日额度</span>
                    <span style="width: 150px"></span>
                    <span style="width: 150px"></span>
                    <span style="width: 150px"></span>
                    <span style="width: 350px">今日份额</span>
                    <span style="width: 150px">用户当前拥有</span>
                    <span style="width: 150px">加权可获得</span>
                </div>
                <el-divider></el-divider>
                <div class="itme-data">
                    <span style="width: 200px">今日活跃贡献值额度：{{ sumTodayMoney.todayActiveScore }}</span>-
                    <el-input style="width: 150px" size="mini" v-model="number1.number1score" disabled></el-input>=
                    <el-input style="width: 150px" size="mini" v-model="number2.number2score" type="number"></el-input>
                    <el-button size="mini" type="primary" @click="onValue(1,number2.number2score,6)">加</el-button>
                    <el-button size="mini" type="danger" @click="onValue(0,number2.number2score,6)">减</el-button>
                    <span style="width: 350px">今日活跃总贡献值：{{ sumTodayShare.todayActiveScore }}</span>
                    <el-input style="width: 150px" size="mini" v-model="share.score" @input="inputScore"></el-input>
                    <el-input style="width: 150px" size="mini" v-model="money.score" @input="inputScore"></el-input>
                </div>
                <el-divider></el-divider>
                <div class="itme-data">
                    <span style="width: 200px">今日活跃悦豆额度：{{ sumTodayMoney.todayActiveCurrency8 }}</span>-
                    <el-input style="width: 150px" size="mini" v-model="number1.number1currency8" disabled></el-input>=
                    <el-input style="width: 150px" size="mini" v-model="number2.number2currency8" type="number"></el-input>
                    <el-button size="mini" type="primary" @click="onValue(1,number2.number2currency8,7)">加</el-button>
                    <el-button size="mini" type="danger" @click="onValue(0,number2.number2currency8,7)">减</el-button>
                    <span style="width: 350px">今日活跃总悦豆：{{ sumTodayShare.todayActiveCurrency8 }}</span>
                    <el-input style="width: 150px" size="mini" v-model="share.currency8" @input="inputCurrency8"></el-input>
                    <el-input style="width: 150px" size="mini" v-model="money.currency8" @input="inputCurrency8"></el-input>
                </div>
                <el-divider></el-divider>
                <div class="itme-data">
                    <span style="width: 200px">今日不活跃贡献值额度：{{ sumTodayMoney.todayInActiveScore }}</span>-
                    <el-input style="width: 150px" size="mini" v-model="number1.number1inScore" disabled></el-input>=
                    <el-input style="width: 150px" size="mini" v-model="number2.number2inScore" type="number"></el-input>
                    <el-button size="mini" type="primary" @click="onValue(1,number2.number2inScore,9)">加</el-button>
                    <el-button size="mini" type="danger" @click="onValue(0,number2.number2inScore,9)">减</el-button>
                    <span style="width: 350px">今日不活跃总贡献值：{{ sumTodayShare.todayInActiveScore }}</span>
                    <el-input style="width: 150px" size="mini" v-model="share.inScore" @input="inputInScore"></el-input>
                    <el-input style="width: 150px" size="mini" v-model="money.inScore" @input="inputInScore"></el-input>
                </div>
                <el-divider></el-divider>
                <div class="itme-data">
                    <span style="width: 200px">今日悦果额度：{{ sumTodayMoney.todayActiveCurrency9 }}</span>-
                    <el-input style="width: 150px" size="mini" v-model="number1.number1currency9" disabled></el-input>=
                    <el-input style="width: 150px" size="mini" v-model="number2.number2currency9" type="number"></el-input>
                    <el-button size="mini" type="primary" @click="onValue(1,number2.number2currency9,10)">加</el-button>
                    <el-button size="mini" type="danger" @click="onValue(0,number2.number2currency9,10)">减</el-button>
                    <span style="width: 350px">今日总悦果：{{ sumTodayShare.todayActiveCurrency9 }}</span>
                    <el-input style="width: 150px" size="mini" v-model="share.currency9" @input="inputCurrency9"></el-input>
                    <el-input style="width: 150px" size="mini" v-model="money.currency9" @input="inputCurrency9"></el-input>
                </div>
                <el-divider></el-divider>
            </div>
        </div>
    </div>
</template>

<script>
import { get } from '@/utils/request.js';
export default {
    data() {
        return {
            getSystemAllMoney: {
                currency8: 0,
                userMoney: 0,
                currency9: 0,
                userScore: 0,
            },
            sumTodayMoney:{
                todayActiveCurrency8: 0,
                todayActiveCurrency9: 0,
                todayActiveScore: 0,
                todayInActiveScore: 0,
            },
            sumTodayShare:{
                todayActiveCurrency8: 0,
                todayActiveCurrency9: 0,
                todayActiveScore: 0,
                todayInActiveScore: 0,
            },
            share:{
                currency8: 0,
                currency9: 0,
                score: 0,
                inScore: 0,
            },
            money:{
                currency8: 0,
                currency9: 0,
                score: 0,
                inScore: 0,
            },
            number1:{
                number1currency8: 0,
                number1currency9: 0,
                number1score: 0,
                number1inScore: 0,
            },
            number2:{
                number2currency8: 0,
                number2currency9: 0,
                number2score: 0,
                number2inScore: 0,
            }
        };
    },
    created() {
        this.getData();
    },
    methods: {
        inputScore(){
            this.number1.number1score = (this.sumTodayShare.todayActiveScore * this.money.score / this.share.score).toFixed(4);
            this.number2.number2score = (this.sumTodayMoney.todayActiveScore - this.number1.number1score).toFixed(4)
        },
        inputCurrency8(){
            this.number1.number1currency8 = (this.sumTodayShare.todayActiveCurrency8 * this.money.currency8 / this.share.currency8).toFixed(4);
            this.number2.number2currency8 = (this.sumTodayMoney.todayActiveCurrency8 - this.number1.number1currency8).toFixed(4)
        },
        inputInScore(){
            this.number1.number1inScore = (this.sumTodayShare.todayInActiveScore * this.money.inScore / this.share.inScore).toFixed(4);
            this.number2.number2inScore = (this.sumTodayMoney.todayInActiveScore - this.number1.number1inScore).toFixed(4)
        },
        inputCurrency9(){
            this.number1.number1currency9 = (this.sumTodayShare.todayActiveCurrency9 * this.money.currency9 / this.share.currency9).toFixed(4);
            this.number2.number2currency9 = (this.sumTodayMoney.todayActiveCurrency9 - this.number1.number1currency9).toFixed(4)
        },

        onValue(orientation,value,valueType){
            if(value <= 0){
                this.$message.error("请输入大于0的数")
                return
            }

            this.$confirm(`确认${orientation ? '添加' : '减少'}：${value}`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                get('/operation/dailyglobaldata/operateGlobalTodayValue',{
                    orientation,
                    value,
                    valueType,
                }).then((res)=>{
                    if(res.success){
                        this.$message.success(res.msg)
                        this.getData();
                    }
                })
            }).catch(() => {
				
            });
        },
        getData(){
            this.getSystemAllMoney1();
            this.sumTodayMoney1();
            this.sumTodayShare1();
        },
        getSystemAllMoney1(){
            get('/operation/dailyglobaldata/getSystemAllMoney').then((res)=>{
                if(res.success){
                    this.getSystemAllMoney.currency8 = res.systemAllMoney.currency8
                    this.getSystemAllMoney.userMoney = res.systemAllMoney.userMoney
                    this.getSystemAllMoney.currency9 = res.systemAllMoney.currency9
                    this.getSystemAllMoney.userScore = res.systemAllMoney.userScore
                }
            })
        },
        sumTodayMoney1(){
            get('/operation/dailyglobaldata/sumTodayMoney').then((res)=>{
                if(res.success){
                    this.sumTodayMoney.todayActiveCurrency8 = res.todayMoney.todayActiveCurrency8
                    this.sumTodayMoney.todayActiveCurrency9 = res.todayMoney.todayActiveCurrency9
                    this.sumTodayMoney.todayActiveScore = res.todayMoney.todayActiveScore
                    this.sumTodayMoney.todayInActiveScore = res.todayMoney.todayInActiveScore
                }
            })
        },
        sumTodayShare1(){
            get('/operation/dailyglobaldata/sumTodayShare').then((res)=>{
                if(res.success){
                    this.sumTodayShare.todayActiveCurrency8 = res.todayShare.todayActiveCurrency8
                    this.sumTodayShare.todayActiveCurrency9 = res.todayShare.todayActiveCurrency9
                    this.sumTodayShare.todayActiveScore = res.todayShare.todayActiveScore
                    this.sumTodayShare.todayInActiveScore = res.todayShare.todayInActiveScore
                }
            })
        },


    }


};
</script>

<style scoped lang="scss">
.my-label{
    width: 100px;
}
.my-content{
    width: 200px;
}

.data-list{
    width: 100%;
    margin-top: 10px;

    .title{
        font-size: 16px;
        font-weight: 700;
        color: #303133;
        margin-bottom: 10px;
    }
    .itme-data{
        width: 100%;
        font-size: 14px;
        display: flex;
        flex-direction: row;
        align-content: center;
        justify-content: space-around;

        .title-txt{
            text-align: center;
        }
    }
}

</style>